import { request } from '@nextgen-web-framework/core';
import { AccountBalanceAccountType, AccountBalanceEntryEntryTypeEnum, PaymentMethodId } from '../models';
import createQueryString from '../utils';
import { ExpiringBalanceResponse } from '../loyaltyModels/pdp/models/ExpiringBalanceResponse';
import { LoyaltyBalanceSummary } from '../loyaltyModels/pdp/models/LoyaltyBalanceSummary';
import { Projection } from '../models/Projection';
import type { CustomRequestOptions } from '../../types';
import { TransactionDetailsPaginatedResponse } from '../models/TransactionDetailsPaginatedResponse';
import { AccountBalancePaginatedResponse } from '../models/AccountBalancePaginatedResponse';
/*
* These Bellow API's as only applicable for Internal Payment Options 
1. AmPoint
2. AmPurse
3. Credit Voucher
*/
const appServiceUrl = '/compaymentas/v1';

const basePath = (baseURL: string) => baseURL + appServiceUrl;
export interface InternalOptionRequestType {
  entryType: AccountBalanceEntryEntryTypeEnum;
  lastEvaluatedKey?: string;
  createdAt?: string;
  pageNumber?: number;
  pageSize?: number;
}
export const InternalOptionsApi = {
  get basePath() {
    const baseUrl = ApiConfigService.getBaseUrl();
    return `${baseUrl}/compaymentas/v1`;
  },

  /**
   *
   * @description - API Call to fetch transactions list
   *
   * @param filterOption Options that will be used to differentiate `AmPoint`, `AmPurse`, `Credit Voucher`
   * And sections `All`, `Redeemed`, `Received` and other's
   *
   * @returns List of Transactions.
   */
  // REMOVE THIS ANY WITH VALIDATE TYPE
  async getTransactionHistory(
    paymentMethodId: AccountBalanceAccountType,
    filterOption: InternalOptionRequestType,
    options?: CustomRequestOptions,
  ): Promise<TransactionDetailsPaginatedResponse> {
    const queryString = createQueryString({
      ...filterOption,
      accountBalanceType: paymentMethodId,
    });
    return await request.get({
      url: `${options?.baseURL ? basePath(options.baseURL) : this.basePath}/account-balance-entries${queryString}`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },

  /**
   * @description - TO BE USED IN FUTURE API Call to fetch Active Credit Vouchers of a User
   *
   * @returns List of Active Credit Voucher's
   */
  async getActiveCreditVouchers(pageNumber: number, options?: CustomRequestOptions) {
    return await request.get({
      url: `${options?.baseURL ? basePath(options.baseURL) : this.basePath}/credit-voucher?pageNumber=${pageNumber}`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },

  /**
   * @description - TO BE USED IN FUTURE API Call to fetch expiring AmPoints
   *
   * @returns List of expiring AmPoints
   */
  async getExpiringAmPoints(options?: CustomRequestOptions): Promise<ExpiringBalanceResponse> {
    const baseUrl = ApiConfigService.getBaseUrl();
    return await request.get({
      url: `${options?.baseURL ? options.baseURL : baseUrl}/comloyaltypointsas/v1/expiring-loyalty-balance`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },

  /**
   * @description -API Call to fetch  AmPoints Balance
   *
   * @returns AmPoints Details
   */
  async getLoyalityBalance(options?: CustomRequestOptions): Promise<LoyaltyBalanceSummary> {
    const baseUrl = ApiConfigService.getBaseUrl();
    return await request.get({
      url: `${options?.baseURL ? options.baseURL : baseUrl}/comloyaltypointsas/v1/loyalty-balances`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },

  /**
   * @description -API Call to fetch  Ampurse Balance
   *
   * @returns Ampurse Details
   */
  async getAmpurseBalance(options?: CustomRequestOptions): Promise<LoyaltyBalanceSummary> {
    return await request.get({
      url: `${options?.baseURL ? basePath(options.baseURL) : this.basePath}/account-balances?accountType=${
        PaymentMethodId.OnAccountBalance
      }`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },

  /**
   * @description -API Call to fetch  Credit Vouchers Total
   *
   * @returns Credit Vouchers Total
   */
  async getCreditVouchersTotal(options?: CustomRequestOptions) {
    return await request.get({
      url: `${options?.baseURL ? basePath(options.baseURL) : this.basePath}/credit-voucher?projection=${
        Projection.Summary
      }`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },

  /**
   * @description -API Call to fetch  Internal Pmp Balance
   */
  async getCvBalance(options?: CustomRequestOptions): Promise<AccountBalancePaginatedResponse> {
    return await request.get({
      url: `${options?.baseURL ? basePath(options.baseURL) : this.basePath}/account-balances?accountType=${
        PaymentMethodId.CreditVoucher
      }`,
      ...(options?.headers && { headers: options?.headers }),
    });
  },
};
